import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { Link as RouterLink } from 'react-router-dom';
import { COPY } from '../copy';
import { PageHeading } from '../shell/PageHeading';
import { usePageTitle } from '../shell/usePageTitle';

export function NotFoundPage() {
  usePageTitle(COPY.notFoundTitle);

  return (
    <Container maxWidth="sm" sx={{ py: { xs: 4, lg: 8 } }}>
      <PageHeading>{COPY.notFoundTitle}</PageHeading>
      <Typography variant="body1" sx={{ mb: 3 }}>
        {COPY.notFoundBody}
      </Typography>
      <Button variant="contained" component={RouterLink} to="/start" nativeButton={false}>
        {COPY.goToStart}
      </Button>
    </Container>
  );
}
